import { useMemo } from 'react';
import { Tag } from 'antd';
import {
  CalendarOutlined,
  UserOutlined,
  FileTextOutlined,
  MedicineBoxOutlined,
  MessageOutlined,
} from '@ant-design/icons';

export const useTypeRender = () => {
  return useMemo(() => {
    return (type: string) => {
      const typeConfigs: {
        [key: string]: {
          icon: React.ReactNode;
          text: string;
          bgColor: string;
          textColor: string;
          borderColor: string;
        };
      } = {
        APPOINTMENT: {
          icon: <CalendarOutlined />,
          text: 'Appointment',
          bgColor: '#e6f7ff',
          textColor: '#096dd9',
          borderColor: '#91d5ff',
        },
        PATIENT: {
          icon: <UserOutlined />,
          text: 'Patient',
          bgColor: '#f6ffed',
          textColor: '#389e0d',
          borderColor: '#b7eb8f',
        },
        LEAD: {
          icon: <FileTextOutlined />,
          text: 'Lead',
          bgColor: '#fff7e6',
          textColor: '#d48806',
          borderColor: '#ffd666',
        },
        FEEDBACK: {
          icon: <MedicineBoxOutlined />,
          text: 'Feedback',
          bgColor: '#f9f0ff',
          textColor: '#531dab',
          borderColor: '#d3adf7',
        },
      };

      const config = typeConfigs[type] || {
        icon: <MessageOutlined />,
        text: type ? type.toLowerCase().replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase()) : '',
        bgColor: '#fafafa',
        textColor: '#8c8c8c',
        borderColor: '#d9d9d9',
      };

      return (
        <Tag
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            fontWeight: 500,
            padding: '4px 8px',
            borderRadius: '6px',
            lineHeight: '1.2',
            backgroundColor: config.bgColor,
            color: config.textColor,
            border: `1px solid ${config.borderColor}`,
          }}
        >
          <span style={{ display: 'flex', alignItems: 'center' }}>
            {config.icon}
          </span>
          <span>{config.text}</span>
        </Tag>
      );
    };
  }, []);
};
